import { render, staticRenderFns } from "./TrainerHeader.vue?vue&type=template&id=61bcdf81&scoped=true"
import script from "./TrainerHeader.vue?vue&type=script&lang=js"
export * from "./TrainerHeader.vue?vue&type=script&lang=js"
import style0 from "./TrainerHeader.vue?vue&type=style&index=0&id=61bcdf81&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61bcdf81",
  null
  
)

export default component.exports